if (!customElements.get("sc-blog-slider")) {
  class SCBlogSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector(".sc-blog-slider__track");
      this.btnPrev = this.querySelector(".sc-blog-slider__btn--prev");
      this.btnNext = this.querySelector(".sc-blog-slider__btn--next");

      if (!this.track) return;

      if (this.btnPrev && this.btnNext) {
        this.btnPrev.addEventListener("click", this.scrollPrev.bind(this));
        this.btnNext.addEventListener("click", this.scrollNext.bind(this));
        this.track.addEventListener("scroll", this.updateButtons.bind(this), {
          passive: true,
        });

        // Initial button state (add a small timeout to let the dom layout finish)
        setTimeout(() => this.updateButtons(), 100);
        window.addEventListener("resize", this.updateButtons.bind(this));
      }
    }

    scrollNext() {
      const item = this.track.querySelector(".sc-blog-slider__item");
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).gap || 0);
      const itemWidth = item.offsetWidth + gap;

      this.track.scrollBy({ left: itemWidth, behavior: "smooth" });
    }

    scrollPrev() {
      const item = this.track.querySelector(".sc-blog-slider__item");
      if (!item) return;
      const gap = parseFloat(getComputedStyle(this.track).gap || 0);
      const itemWidth = item.offsetWidth + gap;

      this.track.scrollBy({ left: -itemWidth, behavior: "smooth" });
    }

    updateButtons() {
      if (!this.btnPrev || !this.btnNext) return;

      // Small delay to ensure layout is updated before checking scroll widths
      setTimeout(() => {
        // Check if at beginning
        if (this.track.scrollLeft <= 5) {
          // small tolerance
          this.btnPrev.setAttribute("disabled", "true");
        } else {
          this.btnPrev.removeAttribute("disabled");
        }

        // Check if at end (allow small pixel tolerance)
        const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft >= maxScrollLeft - 5) {
          this.btnNext.setAttribute("disabled", "true");
        } else {
          this.btnNext.removeAttribute("disabled");
        }
      }, 50);
    }
  }

  customElements.define("sc-blog-slider", SCBlogSlider);
}
